import { fg } from '@atlassian/jira-feature-gating';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskIssueTypesResource } from '@atlassian/jira-router-resources-service-desk-issue-types/src/controllers/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { customerServiceGetStartedRoute } from '@atlassian/jira-router-routes-customer-service-get-started-routes/src/customerServiceGetStartedRoute.tsx';
import { GettingStartedPageSkeleton } from '@atlassian/jira-skeletons/src/ui/getting-started-page/GettingStartedPageSkeleton.tsx';
import { customerServiceGetStartedPageEntryPoint } from '@atlassian/jira-router-routes-customer-service-get-started-entries/src/ui/index.tsx';

export const customerServiceGetStartedRouteEntry = createEntry(
	customerServiceGetStartedRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		perfMetricKey: 'customer-service-get-started-page-load',
		skeleton: GettingStartedPageSkeleton,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			staticProjectSidebarNavigationResource,
			servicedeskIssueTypesResource,
		],

		entryPoint() {
			return fg('jcs-getting-started') ? customerServiceGetStartedPageEntryPoint : undefined;
		},

		component: ErrorPagesNotFound,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-customer-service-get-started-entries/src/customerServiceGetStartedRouteEntry.tsx',
				whichExportToUse: 'customerServiceGetStartedRouteEntry',
			},

			enabled: true,
		},
	}),
);
